import { useStore } from 'vuex';
import { SetActiveOrganization, SetLastOrganizationId } from '~/constants/mutations';
import { OrgEnsured } from '~/constants/actions';

const ARCANE_NAMESPACE = 'https://arcane.anthill.com';

const authMiddleware = async (to, from, next) => {
  const store = useStore();
  const user = store.getters['auth0Store/getAuth'].user;
  const isValid = await store.dispatch('auth0Store/isAuthenticated');

  if (!isValid) {
    next({ name: 'Error', params: { statusCode: 403 } });
    return store.getters['auth0Store/getAuth'].loginWithRedirect();
  }

  if (!user.org_id) {
    // error is named route as we need query params
    next({ name: 'Error', params: { statusCode: 403 } });
    return Promise.resolve();
  }

  const orgId = user.org_id.split('_')[1];
  const id = user.sub.split('|').splice(-1)[0].replaceAll('.', '-').replaceAll('@', '-');

  const email = user[`${ARCANE_NAMESPACE}/email`];
  const roles = user[`${ARCANE_NAMESPACE}/roles`];

  store.dispatch('authStore/setUserData', { orgId, id, email, roles });
  store.dispatch(`authStore/${SetActiveOrganization}`, orgId);
  store.dispatch(`authStore/${SetLastOrganizationId}`, orgId);
  store.dispatch(`authStore/${OrgEnsured}`);

  next();
  return Promise.resolve();
};

export default authMiddleware;
